<template>
  <div>
    <nav class="tab-menu">
      <!-- TKP-91: metin üretimi tek ekranlı sihirbaza taşındı; eski sekmeler geriye uyumluluk için yerinde -->
      <div v-if="canGenerate" :class="{ active: tabFilter === 'wizard' }" @click="tabFilter = 'wizard'" data-test="wizard-tab">
        {{ $t("legal-document-wizard.tab") }}
      </div>
      <div v-if="hasViewTemplatePermission" :class="{ active: tabFilter === 'template' }" @click="tabFilter = 'template'">
        {{ $t("legal-document-template.plural") }}
      </div>
      <div v-if="hasViewTemplatePermission" :class="{ active: tabFilter === 'review' }" @click="tabFilter = 'review'">{{ $t("legal-document-template.waiting-review") }}</div>
      <div v-if="hasViewDocumentPermission" :class="{ active: tabFilter === 'document' }" @click="tabFilter = 'document'">
        {{ $t("legal-document.plural") }}
      </div>
    </nav>
    <LegalDocumentWizard v-if="tabFilter == 'wizard' && canGenerate" product="DDO" />
    <LegalDocumentTemplateView v-if="tabFilter == 'template'" product="DDO" />
    <LegalDocumentReviewView v-if="tabFilter == 'review'" product="DDO" />
    <LegalDocumentView v-if="tabFilter == 'document'" product="DDO" />
  </div>
</template>

<script>
import LegalDocumentReviewView from "./legal-document-review-view";
import LegalDocumentTemplateView from "./legal-document-template-view";
import LegalDocumentWizard from "./legal-document-wizard";
import LegalDocumentView from "./legal-document-view";

export default {
  components: { LegalDocumentTemplateView, LegalDocumentView, LegalDocumentReviewView, LegalDocumentWizard },
  computed: {
    /** TKP-91: sihirbazda metin üretme yetkisi (dokümandaki "hukuk yöneticisi"). */
    canGenerate() {
      return this.currentAccountCan("LEGAL_DOCUMENT_WIZARD__CAN_GENERATE");
    },
    tabFilter: {
      get() {
        return this.$store.getters["organizationLegalDocument/tab"];
      },
      set(tab) {
        this.$store.commit("organizationLegalDocument/tab", tab);
      },
    },

    hasViewTemplatePermission() {
      if (this.currentAccountCan("LEGAL_DOCUMENT_DDO_LEGAL_DOCUMENT_TEMPLATE_VIEW__HAS_VIEW_TEMPLATE_PERMISSION")) {
        return true;
      }

      return false;
    },

    hasViewDocumentPermission() {
      if (this.currentAccountCan("LEGAL_DOCUMENT_DDO_LEGAL_DOCUMENT_TEMPLATE_VIEW__HAS_VIEW_DOCUMENT_PERMISSION")) {
        return true;
      }

      return false;
    },
  },
};
</script>
